import Authentication from '@/modules/authentication/Authentication';

export default [
    {
        path: '/auth/login',
        name: 'login',
        component: Authentication,
    },
    {
        path: '/auth/logout',
        name: 'logout',
    },
];
